import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection } from './components/AgitationSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { ExampleQuestionsSection } from './components/ExampleQuestionsSection';
import { IdealForSection } from './components/IdealForSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <WhatsInsideSection data-id="element-8" />
        <ExampleQuestionsSection data-id="element-9" />
        <IdealForSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <FAQSection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}